import { normalize } from 'normalizr';

import { callApi, pageToOffsetParams } from 'utils/api';
import * as schemas from 'schemas';

export function forumThreadsFetch(page, {
  sort = 'popular',
  live = false,
  following = false,
  askKooth = false,
  pageSize = process.env.KOOTH_PAGE_SIZE,
  topic = []
} = {}) {
  return callApi('/forum/threads', {
    query: {
      sort,
      live,
      askKooth,
      following,
      topic,
      ...pageToOffsetParams(page, pageSize)
    }
  })
  .then(json => {
    const { forumThreads, meta }  = json;
    const { result, entities } = normalize(forumThreads, schemas.forumThreadsArraySchema);

    return {forumThreadsIds: result, entities, meta};
  });
}

export function forumThreadProfileFetch(forumThreadId) {
  return callApi(`/forum/threads/${forumThreadId}`)
  .then(json => {
      const entities = {
        forumThreads: {
          [forumThreadId]: json
        }
      };

      return {forumThreadsIds: [forumThreadId], entities};
  });
}

export function forumThreadFollow(forumThreadId, following) {
  return callApi(`/forum/threads/${forumThreadId}/following`, {
    method: 'POST',
    body: {
      following
    }
  });
}

export function forumThreadCreate({ title, text, askKooth = false }) {
  return callApi('/forum/threads', {
    method: 'POST',
    body: {
      title,
      text,
      askKooth
    }
  });
}



/** WEBPACK FOOTER **
 ** ./src/members/state/forum/api.js
 **/